import { call, put, takeEvery } from '@redux-saga/core/effects';
import { createAction, handleActions } from 'redux-actions';
import { defaultGridData } from '../../../module/component/TableBoxModule';
import { HOME_PATH, PATH_DELIMITER, SUBJECT_SEARCH_BODY_PATH } from '../../../constant/Constant';
import NullCheckUtil from '../../../util/NullCheckUtil';
import { request } from '../../ApiModule';
import { SET_GRID_DATA } from '../../component/TableBoxModule';
import { SET_NO_PAGE_GRID_DATA } from '../../component/TableNoPageBoxModule';

const INIT = SUBJECT_SEARCH_BODY_PATH + PATH_DELIMITER + 'INIT';
const ACTION_SUBJECT_SEARCH = SUBJECT_SEARCH_BODY_PATH + PATH_DELIMITER + 'ACTION_SUBJECT_SEARCH';
const ACTION_ENROLMENT_SEARCH = SUBJECT_SEARCH_BODY_PATH + PATH_DELIMITER + 'ACTION_ENROLMENT_SEARCH';
const ACTION_ENROLMENT_ADD = SUBJECT_SEARCH_BODY_PATH + PATH_DELIMITER + 'ACTION_ENROLMENT_ADD';
const ACTION_ENROLMENT_REMOVE = SUBJECT_SEARCH_BODY_PATH + PATH_DELIMITER + 'ACTION_ENROLMENT_REMOVE';
const ACTION_SEMESTER_SEARCH = SUBJECT_SEARCH_BODY_PATH + PATH_DELIMITER + 'ACTION_SEMESTER_SEARCH';
const HANDLE_SEMESTER = SUBJECT_SEARCH_BODY_PATH + PATH_DELIMITER + 'HANDLE_SEMESTER';

export const actionInit = createAction(INIT);
export const actionSubjectSearch = createAction(ACTION_SUBJECT_SEARCH);
export const actionEnrolmentSearch = createAction(ACTION_ENROLMENT_SEARCH);
export const actionEnrolmentAdd = createAction(ACTION_ENROLMENT_ADD);
export const actionEnrolmentRemove = createAction(ACTION_ENROLMENT_REMOVE);
export const actionSemesterSearch = createAction(ACTION_SEMESTER_SEARCH);

export function* enrolmentSearchSubjectSagas() {
    yield takeEvery(ACTION_SUBJECT_SEARCH, actionSubjectSearchSaga);
    yield takeEvery(ACTION_ENROLMENT_SEARCH, actionEnrolmentSearchSaga);
    yield takeEvery(ACTION_ENROLMENT_ADD, actionEnrolmentAddSaga);
    yield takeEvery(ACTION_ENROLMENT_REMOVE, actionEnrolmentRemoveSaga);
    yield takeEvery(ACTION_SEMESTER_SEARCH, actionSemesterSearchSaga);
}

function* actionSubjectSearchSaga({ payload: { params, callback } }) {
    const result = yield call(request, {
        method: 'get',
        url: `/api/course/semesters/${params.semesterId}/universities/${params.userUniversityCd}/enrolment`,
        params,
        callback,
    });
    if (NullCheckUtil.isNotNull(result)) {
        yield put({
            type: SET_GRID_DATA,
            payload: {
                ...result,
                rows: result.rows.map((row) => ({ ...row.courseInfo, courseTimes: row.courseTimes })),
            },
        });
    }
}

function* actionEnrolmentSearchSaga({ payload: { params } }) {
    const result = yield call(request, {
        method: 'get',
        url: `/api/enrolment/semesters/${params.semesterId}/by-user`,
        params,
    });
    if (NullCheckUtil.isNotNull(result)) {
        yield put({
            type: SET_NO_PAGE_GRID_DATA,
            payload: {
                ...result,
                rows: result.rows.map((row) => ({ ...row.courseInfo, courseTimes: row.courseTimes })),
            },
        });
    }
}

function* actionEnrolmentAddSaga({ payload: { data, callback } }) {
    const result = yield call(request, {
        method: 'post',
        url: `/api/enrolment/semesters/${data.semesterId}/universities/${data.lessonUniversityCd}/subjects/${data.subjectId}/classes/${data.classNo}/users/${data.userId}/universitySubjects`,
        data,
        callback,
    });
}

function* actionEnrolmentRemoveSaga({ payload: { data, callback } }) {
    const result = yield call(request, {
        method: 'delete',
        url: `/api/enrolment/semesters/${data.semesterId}/universities/${data.lessonUniversityCd}/subjects/${data.subjectId}/classes/${data.classNo}/users/${data.userId}/universitySubjects/${data.universitySubjectId}`,
        callback,
    });
}

function* actionSemesterSearchSaga({ payload: { params, callback } }) {
    const result = yield call(request, {
        method: 'get',
        url: `/api/semesters/${params.semesterId}`,
    });
    if (NullCheckUtil.isNotNull(result)) {
        yield put({
            type: HANDLE_SEMESTER,
            payload: result,
        });
    } else {
        callback();
    }
}

const initialState = {
    semester: null,
};

const module = handleActions(
    {
        [INIT]: () => initialState,
        [HANDLE_SEMESTER]: (state, { payload: semester }) => ({ ...state, semester }),
    },
    initialState,
);

export default module;
